import React, { useState } from "react";
import { Box, Button, Paper, Typography } from "@mui/material";
import { AddCircle } from "@mui/icons-material";
import Grid from "@mui/material/Unstable_Grid2";
import { Link } from "react-router-dom";
import { Collection } from "../../types/collections.types";
import { FilterDialog } from "../filters/FilterDialog";
import { useStore } from "../../store/store";
import { FilterAlt } from "@mui/icons-material";
import { SelectSettings } from "../configColumns/SelectSettings";

type RecordsHeaderProps = {
    collection: Collection;
    hideCreateButton?: boolean;
	hideSettingsButton?: boolean;
	hideFiltersButton?: boolean;
    optionalComponents?: {
        headerTitle?: string;
        bellowTitle?: React.ReactNode;
        leftOfButtons?: React.ReactNode;
    };
};

export const RecordsHeader = ({ collection, hideCreateButton, hideSettingsButton, hideFiltersButton, optionalComponents }: RecordsHeaderProps) => {
	const [filtersIsOpen, setFilterIsOpen] = useState<boolean>(false);
    const [recordsFilter, selectedSettings] = useStore((state) => [
		state.recordsFilter || state.gridSettings.selectedSettings?.config?.filters?.records,
		state.gridSettings.selectedSettings,
    ]);
    const currentEntityFilters = recordsFilter && recordsFilter[collection.collection];
	const isSystemNonDefault = selectedSettings?.isSystem && selectedSettings?.name !== "Default";
	const { leftSide, rightSide } = getGridDimensionByCollection(collection.collection)

    return (
		<>
			<Paper elevation={1} sx={{ mt: 2, mb: 2, p: 6, minHeight: 100 }}>
				<Grid
					container
					alignItems="center"
					justifyContent="space-between"
					rowSpacing={5}
				>
					<Grid {...leftSide} display="flex" flexDirection="column" gap={2}>
						<Grid display="flex" alignItems="center" gap={4}>
							<Typography variant="h4">
								{optionalComponents?.headerTitle ||
									(collection.meta.translations && collection.meta.translations[0].plural)}
							</Typography>
							{hideSettingsButton ? null : (
								<Grid minWidth={"250px"}>
									<SelectSettings />
								</Grid>
							)}
						</Grid>
						<Box sx={{ alignSelf: "flex-start" }}>
							{optionalComponents?.bellowTitle}
						</Box>
					</Grid>
					<Grid
						{...rightSide}
						display="flex"
						flexDirection={{
							xs: "column",
							mdl: optionalComponents?.leftOfButtons ? "row" : "column",
							xl: "column",
							xxl: "row",
						}}
						alignItems={"flex-end"}
						justifyContent="flex-end"
						columnGap={2}
						rowGap={optionalComponents?.leftOfButtons ? 6 : 2}
					>
						<Grid>{optionalComponents?.leftOfButtons}</Grid>

						<Grid
							display="flex"
							flexDirection={{
								xs: "row",
								mdl: optionalComponents?.leftOfButtons ? "column" : "row",
								lg:"row",
							}}
							rowGap={6}
							columnGap={4}
							alignItems="flex-end"
						>
							{hideFiltersButton ? null : (
								<Grid>
									<Button
										startIcon={currentEntityFilters ? <FilterAlt /> : null}
										color="secondary"
										size="large"
										disabled={!!isSystemNonDefault}
										onClick={() => setFilterIsOpen(true)}
									>
										{currentEntityFilters ? "Editar Filtros" : "Filtrar"}
									</Button>
								</Grid>
							)}
							{hideCreateButton ? null : (
								<Grid>
									<Button
										component={Link}
										to={`/${collection.collection}/create`}
										startIcon={<AddCircle />}
									>
										Criar
									</Button>
								</Grid>
							)}
						</Grid>
					</Grid>
				</Grid>
			</Paper>
			<FilterDialog filtersIsOpen={filtersIsOpen} setFilterIsOpen={setFilterIsOpen} />
		</>
	);
};


	const getGridDimensionByCollection = (collection: string) => {
		const collectionDimension = {
			"tasks": {
				leftSide: {
					xs: 12,
					lg: 8,
					xl: 6.4
				},
				rightSide: {
					xs: 12,
					lg: 4,
					xl: 5.6

				}
			},
			"default": {
				leftSide: {
					xs: 12,
					lg: 5.5,
					xl: 3.6
				},
				rightSide: {
					xs: 12,
					lg: 6.5,
					xl: 8

				}
			}
		}

		const selectedDimensions = collectionDimension[collection as keyof typeof collectionDimension] || collectionDimension.default
		return selectedDimensions

	}
